import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { ViewedStandardTriageWarningPageEventTracking } from '@/modules/auth/models/segmentevents/ViewedStandardTriageWarningPageEventTracking';

export class StandardTriageWarningPageCompletedEventTracking extends ViewedStandardTriageWarningPageEventTracking {
  static eventName: SegmentEvent = SegmentEvent.STANDARD_TRIAGE_WARNING_PAGE_COMPLETED;
}
